import React from 'react';
import './emptys.scss';
import Header from '../../components/Headers/Header';

function index() {
  return (
    <div>
      <Header />

      <div className="wrapper_empty">
        <section className="empty">
          <article className="empty_info">
            <p className="empty_h2">
              Te invitamos a contactar un abogado o despacho.
                </p>
            <p className="empty_text">
              La mejor asesoria al alcance de un click.
                </p>
            <button className="empty_btn">Buscar abogados</button>
          </article>
          <figure className="empty_fig">
            <img src="/img/emptys/pantalla-vacia.svg" alt="" />
          </figure>
        </section>
      </div>

    </div>
  );
}

export default index;
